import {
    Container,
    Form,
    Button,
  } from "react-bootstrap";
  
  import React, {useEffect, useState} from 'react';
  import { useNavigate } from "react-router-dom";
  import * as VhfLang from "./VhfLang";
  import StepperHelper from "../../helper/stepperHelper/StepperHelper"



const PrivateOrCompany = () => {
    
    const [selected, setSelected] = useState('private');
    const [nav, setNav] = useState('/vhf/privateContact');

    const [showNoBankIdEService, setShowNoBankIdEService] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
      sessionStorage.setItem(VhfLang.IsPrivateContact, sessionStorage.getItem(VhfLang.IsPrivateContact)=='true');
    },[])


    const handleChange = event => {
        //console.log(event.target.value);
        if(event.target.id==="private"){
          sessionStorage.setItem(VhfLang.IsPrivateContact, true);
            setSelected("private");
            setNav(VhfLang.NavPrivateContactInfo)
            sessionStorage.removeItem(VhfLang.KeyForSessionForCompanyContact)
            
        }
        else if(event.target.id==="company"){
            setSelected("company");
            setNav(VhfLang.NavCompanyContactInfo)
            sessionStorage.setItem(VhfLang.IsPrivateContact, false);
            sessionStorage.removeItem(VhfLang.KeyForSessionForPrivateContact)
            sessionStorage.removeItem(VhfLang.SpecialPostAddressId)
            sessionStorage.removeItem(VhfLang.UseForMarketingId)
        }
      };



      var isPrivateContact=sessionStorage.getItem(VhfLang.IsPrivateContact);
      if(isPrivateContact!=null){
       if(isPrivateContact=='false'&&selected=='private'){
        setSelected("company");
        setNav(VhfLang.NavCompanyContactInfo)
      }
    }

      const onSubmit = (values) => {
        
        
        navigate(nav);
      };

      const onShowNoBankIdEService = () => {
        
        if(showNoBankIdEService)setShowNoBankIdEService(false);
        else setShowNoBankIdEService(true);
      };


return ( 
   <>
  

 
	
<fieldset className="spaceBetweenFieldSetLarge" >
  <h1>Tillstånd för VHF i fritidsbåt och fartyg</h1>
	<br></br>
  <p>Välkommen till Post och telestyrelsens (PTS) e-tjänst för ansökan om båtradio (VHF). Läs mer om <a href="https://www.pts.se/tillstand-och-anmalan/radio/batradio-vhf/" target="_blank" className="fontBoldPurple">båtradio på pts.se</a>.</p>
    <b>Privatpersoner med BankID</b> ansöker enklast och snabbast via e-tjänsten med automatisk handläggning. 
    <p>Du kan ansöka om nytt tillstånd, göra ändringar i eller annullera befintliga tillstånd. </p>
	
    <Button variant="default" href="https://vhf.pts.se" >E-tjänst för VHF</Button>
 
    <br/><br/>
    <b>Organisationer</b> eller <b>privatpersoner utan BankID</b> ansöker istället via ett formulär med manuell handläggning. 
    <br/><br/>
    <p>
    
     <Button variant="default" onClick={onShowNoBankIdEService} >Formulär för VHF</Button>
    </p>

</fieldset>


{showNoBankIdEService&&
<Form className="spaceBetweenFieldSetLarge"  >



<StepperHelper activeStep={0} otherHeader={<h2>{VhfLang.HeaderStepper}</h2>}></StepperHelper>
      
    <fieldset>
        <h2>{VhfLang.PrivateOrCompanyLegend}</h2>
        <div key="ChooseId1" className="mb-3">
          <Form.Check
            inline
            label="Privatperson (utan BankID)"
            name="group1"
            type="radio"
            id="private"
            checked={selected === 'private'}
            onChange={handleChange}
          />
          </div>

          <div key="ChooseId2" className="mb-3">
          <Form.Check
            inline
            label="Organisation"
            name="group1"
            type="radio"
            id="company"
            checked={selected === 'company'}
            onChange={handleChange}
          />
          </div>
          <div className="float-end">
            <Button variant="forward" type="submit" onClick={onSubmit} className="button-margin" >
              {VhfLang.ButtonNextDisplay}
             </Button>
          </div>
          
          </fieldset>      
       
      
    </Form>}
    </>   
 
    
)

}
export default PrivateOrCompany